import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Button } from "../components/ui/button";
import { ChevronRight, FileText, ArrowLeft } from "lucide-react";

export const DocsX402Page = () => {
  return (
    <div className="pt-24" data-testid="docs-x402-page">
      <Seo
        title="x402 Payment Scheme (preview) | SwarmCitadel Docs"
        description="Preview documentation for SwarmCitadel x402 payment scheme integration. Govern agent payments over the open x402 standard with policy enforcement and audit trails."
        path="/docs/x402"
      />

      {/* Header */}
      <section className="py-12 md:py-16 relative overflow-hidden border-b border-swarm-border">
        <div className="absolute inset-0 bg-mesh opacity-50" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <Link 
            to="/docs" 
            className="inline-flex items-center gap-2 text-slate-400 hover:text-white text-sm mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Documentation
          </Link>
          
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-500 text-sm font-medium mb-4">
            Preview
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            x402 Payment Scheme
          </h1>
          <p className="text-slate-400 text-lg">
            Integration documentation for governing agent payments over the open x402 standard.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="glass-card p-8 border-swarm-cyan/20">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-swarm-cyan/10 flex items-center justify-center flex-shrink-0">
                <FileText className="w-6 h-6 text-swarm-cyan" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-2">Overview</h2>
                <p className="text-slate-400 leading-relaxed">
                  x402 is an open payment standard that enables AI agents to pay for API access over HTTP using stablecoins. SwarmCitadel adds the governance layer: policy evaluation before every payment, counterparty controls, budget enforcement, and tamper-evident audit trails linking decisions to on-chain transactions.
                </p>
              </div>
            </div>
            
            <div className="bg-swarm-darker/50 rounded-lg p-6 border border-swarm-border">
              <p className="text-slate-300 text-center">
                Full integration docs coming with the x402 scheme release.
              </p>
            </div>
          </div>

          {/* Related Links */}
          <div className="mt-8">
            <h3 className="text-lg font-semibold text-white mb-4">Related</h3>
            <div className="flex flex-wrap gap-4">
              <Link to="/x402" className="text-swarm-cyan hover:underline text-sm">
                x402 Agent Payments overview
              </Link>
              <span className="text-slate-600">|</span>
              <Link to="/product" className="text-swarm-cyan hover:underline text-sm">
                SwarmCitadel platform
              </Link>
              <span className="text-slate-600">|</span>
              <Link to="/docs" className="text-swarm-cyan hover:underline text-sm">
                All documentation
              </Link>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-12 text-center">
            <p className="text-slate-400 mb-4">
              Want early access to the x402 integration?
            </p>
            <Link to="/contact">
              <Button className="btn-glow" data-testid="docs-x402-cta">
                Request demo access
                <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DocsX402Page;
